import React from 'react';
import { map, get  } from 'lodash';
import { button as Button } from 'modules/button';

// local dependecies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { entityInfoCells as EntityInfoCells } from 'ui/views/widgets/entityInfoCells';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { controlledDrugReorder as ControlledDrugReorder } from 'ui/views/widgets/controlledDrugReorder';
 *
 * // render
 * <ControlledDrugReorder propName='propValue'/>
 */
export const controlledDrugReorder = ( props ) => {

    const columns = get( props, 'primaryColumns' );
    const values = get( props, 'state.values' );

    return (
        <div className='ui-controlled-drug-reorder'>
            <div className='ui-controlled-drug-reorder__header'>

                {/* title for the modal */}
                <div className='ui-controlled-drug-reorder__header__title'>
                    { getLabel( props.title ) }
                </div>

                {/* close button */}
                <div className='ui-error-overlay__head__close' onClick={ () => props.closeOverlay() }>
                    <Icon name='close' width='14' height='14' fill='#ffffff' />
                </div>
            </div>
            <div className='ui-controlled-drug-reorder__body'>
                <div className='ui-controlled-drug-reorder__body__items'>
                    <EntityInfoCells
                        items={ columns }
                        values={ values }
                        className='ui-controlled-drug-reorder__body__items__primary__cell'
                        cellClassName={ 'ui-controlled-drug-reorder__body__items__primary__cell__view' }
                    />
                </div>
                <div className='ui-controlled-drug-reorder__body__description'>
                    <div className='ui-controlled-drug-reorder__body__description__icon'>
                        <Icon id={ 'flagError' } />
                    </div>
                    <div className='ui-controlled-drug-reorder__body__description__value'>
                        { getLabel( get( props, 'reorderInfo.description' ) ) }
                    </div>
                </div>

            {/* button actions */}
            <div className='ui-controlled-drug-reorder__body__actions'>
                { map( props.actions, action => {
                    return (
                        <Button
                            key={ action.name }
                            { ...action }
                            outline={ 'cancel' === action.name ? true: false }
                            size='large'
                            className='ui-controlled-drug-reorder__body__actions__action'
                            onClick={ () => 'cancel' !== action.name ? props.setAdd( true ) : props.onCancelClick() }
                        />
                    );
                } ) }
            </div>

            </div>

        </div>
    );
};

// set display name
controlledDrugReorder.displayName = 'orderToDo';

// set default props
controlledDrugReorder.defaultProps = {};

// prop types
controlledDrugReorder.propTypes = {};
